export default class Submenu {
  #name = ""
  #path = ""
  #url = ""

  static fromJSONResponse(json) {
    return new Submenu()
      .setName(json.name)
      .setPath(json.path)
      .setUrl(json.url)
  }

  getName() {
    return this.#name
  }

  getUrl() {
    return this.#url
  }

  getPath() {
    return this.#path
  }

  setName(value) {
    this.#name = value
    return this
  }

  setUrl(value) {
    this.#url = value;
    return this
  }

  setPath(value) {
    this.#path = value
    return this
  }

}
